import { Button, Card, Checkbox, Divider, Flex, Form, Image, Input, Space, theme, Drawer, Modal } from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import { EyeTwoTone, EyeInvisibleOutlined, GoogleOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { json, useNavigate } from "react-router-dom";
import UserRecoveryService from "services/user_recovery";

import { useEffect, useState } from "react";
import { useApp } from "contexts/app";

const service = new UserRecoveryService();


function Register() {
    const { token } = theme.useToken();
    const [form] = useForm();
    const [otpForm] = useForm();
    const { loading, showLoading, message } = useApp();


    const navigate = useNavigate();
    const [idOtp, setIdOtp] = useState();
    const [isShowOtp, setIshowOpt] = useState(false)

    const email = useWatch("email", { form });
    const agree = useWatch("agree", { form })

    const handleCreate = () => {
        form.submit();
    };
    useEffect(() => {
     //   form.setFieldsValue({ phone: "0911275168", pass: "112233", re_pass: "112233", full_name: "Vũ Văn Toàn", agree: true });

    }, [])


    const onFinish = async () => {

        const data = { ...form.getFieldsValue() };
        showLoading(true);
        var { otp } = await service.requestResetPass(data);
        // var { otp } = { "otp": { "id": "2247afbb-51b5-46c0-812c-e7692199b208" } };
        setIdOtp(otp.id);
        console.log()
        showLoading(false)
        setIshowOpt(true)

    };

    const onOtpFinish = async () => {
        const data = { ...otpForm.getFieldsValue() };
        console.log({ data, idOtp, post: { id: idOtp, otp: data.otp } });
        showLoading(true);
        try {
            var createdUser = await service.changePassWithOTP({ id: idOtp, otp: data.otp });
            if (createdUser) {
                navigate("/passreseted")
            }
        } catch (error) {
            message.error(error.message)
        }

        showLoading(false)

    }





    return (
        <Card style={{ width: "500px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <Flex vertical gap={14}>
                <Space direction="vertical" style={{ textAlign: "center" }}>
                    <img width={200} style={{ borderRadius: "8px" }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />

                    <span style={{ fontSize: token.fontSizeHeading3, fontWeight: "500" }}>Đặt lại mật khẩu</span>

                </Space>



                <Form layout="vertical" form={form} initialValues={{}} onFinish={() => onFinish("signUp")}>
                    <Form.Item
                        label="Số điện thoại"
                        name="phone"
                        rules={[
                            {
                                required: true,
                                pattern: /^[0-9]{10}$/,
                                message: "Số điện thoại không đúng định dạng",

                            },



                        ]}
                    >
                        <Input placeholder="Phone"></Input>
                    </Form.Item>



                    <Form.Item
                        label="Password"
                        name="pass"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>

                    <Form.Item
                        label="RePassword"
                        name="re_pass"
                        rules={[
                            {
                                required: true,
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("pass") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("The two passwords do not match!"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>




                    <Space direction="vertical" style={{ width: "100%" }} size={"large"}>
                        <Button type="primary" style={{ width: "100%" }} onClick={() => handleCreate()} >
                            Đặt lại
                        </Button>




                        <Flex align="center" justify="center">
                            <span>Already have an account?</span>
                            <Button type="link" onClick={() => navigate("/login")}>
                                Login
                            </Button>
                        </Flex>
                    </Space>
                </Form>

            </Flex>
            <Modal
                title="Xác nhận otp"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isShowOtp}
                onOk={e => otpForm.submit()}
                onCancel={e => setIshowOpt(false)}
                onClose={e => setIshowOpt(false)}
                okText="Xác nhận"
            >

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>


                    <Form layout="vertical" form={otpForm} initialValues={{}} onFinish={onOtpFinish} style={{ width: 300 }} >

                        <Form.Item
                            label="OTP"
                            name="otp"
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    pattern: /^[0-9]{4}$/,
                                    message: "OTP must be a 4-digit number",
                                },
                            ]}
                        >
                            <Input.OTP length={4} style={{ width: "100%" }} />
                        </Form.Item>


                    </Form>
                </div>
            </Modal>
        </Card >
    );
}

export default Register;
